import React, { useState, useContext, useRef } from "react";
import MonthButton from "./MonthButton";
import { AppContext } from "../../../AppContext";

const NUMBER_OF_MONTHS_TO_DISPLAY = 8;
const MONTH_LOOKUP = {
    1: "ינואר",
    2: "פברואר",
    3: "מרץ",
    4: "אפריל",
    5: "מאי",
    6: "יוני",
    7: "יולי",
    8: "אוגוסט",
    9: "ספטמבר",
    10: "אוקטובר",
    11: "נובמבר",
    12: "דצמבר"
};
export default function MonthNavigator() {
    const { selectedMonthId, selectedYear, setSelectedYear, setSelectedMonthId } = useContext(AppContext);

    const selectedItem = `${selectedYear}-${selectedMonthId}`;
    const { months, refs } = generateItems();
    const monthRefs = useRef(refs);

    //that way we can scroll into view when swiping changes the selected month
    monthRefs?.current?.[selectedItem]?.current?.scrollIntoView({block: "center", inline: "center"});

    const onMonthClick = (month) => {
        const parts = month.split("-");
        const year = parts[0];
        const monthIndex = parts[1];

        setSelectedMonthId(monthIndex);
        setSelectedYear(year);
    };

    function generateItems() {
        const months = {};
        const refs = {};
        const now = new Date();
        let year = now.getFullYear();
        let month = now.getMonth() + 1;
        for (let i = 0; i < NUMBER_OF_MONTHS_TO_DISPLAY; i++) {
            const key = `${year}-${month}`;
            months[key] = [];
            months[key].push(`${year.toString().substring(2, 4)} ${MONTH_LOOKUP[month]}`);
            month -= 1;
            if (month === 0) {
                month = 12;
                year -= 1;
            }
            refs[key] = React.createRef();
        }

        return { months, refs };
    }

    return (
        <div
            style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                height: "66px",
                background: "white"
            }}
        >
            <div
                style={{
                    width: "100%",
                    display: "flex",
                    flexWrap: "wrap",
                    overflowX: "auto",
                    alignItems: "center"
                }}
            >
                <div style={{ display: "flex", flexDirection: "row" }}>
                    {Object.keys(months).map((month, index) => {
                        return (
                            <div key={`month-${month}-${index}`} id={`month-${month}-${index}`} ref={monthRefs.current[month]}>
                                <MonthButton
                                    key={month}
                                    monthIndex={month}
                                    monthDescription={months[month]}
                                    selected={selectedItem === month}
                                    monthSelected={() => {
                                        onMonthClick(month);
                                    }}
                                ></MonthButton>
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
}
